import { render, staticRenderFns } from "./cooperationItem.vue?vue&type=template&id=370a3322&"
import script from "./cooperationItem.vue?vue&type=script&lang=js&"
export * from "./cooperationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports